import CardSection from './CardSection'
import MultiSelect from './MultiSelect'
import PickList from './PickList'
import StateForm from './stateForm/StateForm'
import PdfPager from '../../pdf/PdfPager'
import DocumentNavigator from '../../documents/DocumentNavigator'

/**
 * The widgets a modal form can contain.
 *
 * `ModalForm` renders an element by looking its `type` up here — it never
 * imports one directly. That is what makes the type an extension point rather
 * than a branch in a chain: adding a widget is a file and a line, and a modal
 * that declares none pulls none of this in.
 *
 * Anything not listed is a form field, and falls through to `FormElem` — which
 * is where 21 of the 29 declared groups end up, because most of what a modal
 * contains is an ordinary input.
 */
export const WIDGETS = {
    cardSection:    CardSection,
    multiSelect:    MultiSelect,
    pickList:       PickList,
    stateForm:      StateForm,
    pdf:            PdfPager,
    // The side panel's document viewer, for a phone, where the panel is not
    // shown. The element carries the same keys as the panel section's meta.
    documentNavigator: ({ element, entity }) =>
        <DocumentNavigator meta={element} entity={element.entity ?? entity} />,
}

export const widgetFor = (type) => WIDGETS[type]
